import { render, staticRenderFns } from "./ListCompany.vue?vue&type=template&id=2c036ad9"
import script from "./ListCompany.vue?vue&type=script&lang=js"
export * from "./ListCompany.vue?vue&type=script&lang=js"
import style0 from "./ListCompany.vue?vue&type=style&index=0&id=2c036ad9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports